export const isDebugModeEnabled = () => document.cookie.includes('teamleader_focus_debug_mode=enabled');
